/*
 * Bleach-Free Home Pack — build-your-own-bundle (tiered, no gate)
 * Anchor product (Mould Spray) is always included at full price.
 * The more add-ons the customer picks, the bigger the discount (tiers):
 *   1 add-on = 20%, 2 = 25%, 3+ = 30% (configurable). Minimum 1 add-on.
 * Size is LOCKED per product (bottles -> 500 ml, powders -> 1.5 Kg), shown as a
 * pill; only scent stays selectable. Variants read live from the product object.
 * Adds all lines via the theme cart-add endpoint, tags the add-ons so a tiered
 * Discount Function can take the matching % off them, then opens the cart drawer.
 *
 * Line-item properties:
 *   Add-ons:  _pack = <packTag>   _pack_role = addon      <-- discount matches THIS
 *   Anchor:   _pack_role = anchor   _bundle = <packTag>   (no _pack key -> full price)
 */
(function () {
  function money(cents, cfg) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents, cfg.moneyFormat); } catch (e) {}
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/\s+/g, ''); }

  function findVariant(product, selectedValues) {
    return product.variants.find(function (v) {
      if (!v.options || v.options.length !== selectedValues.length) return false;
      return v.options.every(function (val, i) { return val === selectedValues[i]; });
    });
  }
  function defaultVariant(product) {
    return product.variants.find(function (v) { return v.available; }) || product.variants[0] || null;
  }
  function sizeOptIndex(product) {
    for (var i = 0; i < product.options.length; i++) {
      if (String(product.options[i].name).toLowerCase() === 'size') return i;
    }
    return -1;
  }
  function lockedSize(product) {
    if (!product.lockSize) return null;
    var oi = sizeOptIndex(product);
    if (oi < 0) return null;
    var opt = product.options[oi];
    for (var i = 0; i < opt.values.length; i++) {
      if (norm(opt.values[i]) === norm(product.lockSize)) return { index: oi, value: opt.values[i] };
    }
    return null;
  }
  function defaultValues(product) {
    var lock = lockedSize(product);
    var cands = product.variants.filter(function (v) { return !lock || v.options[lock.index] === lock.value; });
    var pick = cands.find(function (v) { return v.available; }) || cands[0] || defaultVariant(product);
    return pick ? pick.options.slice() : [];
  }
  function anyAvailableAtLock(product) {
    var lock = lockedSize(product);
    return product.variants.some(function (v) { return (!lock || v.options[lock.index] === lock.value) && v.available; });
  }
  function scentOptIndex(product) {
    for (var i = 0; i < product.options.length; i++) {
      if (String(product.options[i].name).toLowerCase() === 'scent') return i;
    }
    return -1;
  }
  // Single fixed variant: locked size + the pack scent (fallback: any available at the locked size).
  function fixedVariant(product, scent) {
    var lock = lockedSize(product);
    var atLock = product.variants.filter(function (v) { return !lock || v.options[lock.index] === lock.value; });
    var si = scentOptIndex(product);
    var pick = null;
    if (si >= 0 && scent) {
      pick = atLock.find(function (v) { return v.available && norm(v.options[si]) === norm(scent); });
      if (!pick) pick = atLock.find(function (v) { return norm(v.options[si]) === norm(scent); });
    }
    if (!pick) pick = atLock.find(function (v) { return v.available; }) || atLock[0] || defaultVariant(product);
    return pick;
  }
  function buildSelect(opt, current, onChange) {
    var wrap = document.createElement('label');
    wrap.className = 'bfp-field';
    var span = document.createElement('span');
    span.className = 'bfp-field__label';
    span.textContent = opt.name;
    var sel = document.createElement('select');
    sel.className = 'bfp-field__select';
    opt.values.forEach(function (val) {
      var o = document.createElement('option');
      o.value = val; o.textContent = val;
      if (val === current) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () { onChange(sel.value); });
    wrap.appendChild(span); wrap.appendChild(sel);
    return wrap;
  }

  function initRoot(root) {
    var cfgEl = document.getElementById(root.getAttribute('data-config-id'));
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[BFP] config parse failed', e); return; }
    if (!cfg.pool || !cfg.pool.length) {
      console.warn('[BFP] missing pool products — check the handles.');
      return;
    }
    if (!cfg.anchorless && (!cfg.anchor || !cfg.anchor.id)) {
      console.warn('[BFP] missing anchor product — check the handle or enable add-ons-only.');
      return;
    }

    var TIERS = (cfg.tiers && cfg.tiers.length ? cfg.tiers.slice() : [{ min: 1, pct: 20 }]).sort(function (a, b) { return a.min - b.min; });
    var MIN = cfg.minAddons || TIERS[0].min || 1;
    var MAX = cfg.maxAddons || TIERS[TIERS.length - 1].min || 3; // cap: pick up to this many add-ons
    var ENTRY = TIERS[0].pct;
    var SCENT = cfg.packScent || ''; // single fixed scent — no scent choice on cards
    var FREE = (cfg.freeShipThreshold || 0) * 100; // dollars -> cents
    var anchor = cfg.anchor;

    function tierPct(n) { var p = 0; for (var i = 0; i < TIERS.length; i++) { if (n >= TIERS[i].min) p = TIERS[i].pct; } return p; }
    function nextTier(n) { for (var i = 0; i < TIERS.length; i++) { if (n < TIERS[i].min) return TIERS[i]; } return null; }

    var state = { anchorValues: anchor ? defaultValues(anchor) : [], anchorVariant: null, selected: {} };
    if (anchor) state.anchorVariant = findVariant(anchor, state.anchorValues) || defaultVariant(anchor);

    var el = {
      pool: root.querySelector('[data-bfp-pool]'),
      counter: root.querySelector('[data-bfp-counter]'),
      tiers: root.querySelector('[data-bfp-tiers]'),
      subtotal: root.querySelector('[data-bfp-subtotal]'),
      saving: root.querySelector('[data-bfp-saving]'),
      savingPct: root.querySelector('[data-bfp-saving-pct]'),
      total: root.querySelector('[data-bfp-total]'),
      freeship: root.querySelector('[data-bfp-freeship]'),
      cta: root.querySelector('[data-bfp-add]'),
      ctaLabel: root.querySelector('[data-bfp-add-label]'),
      error: root.querySelector('[data-bfp-error]'),
      anchorOptions: root.querySelector('[data-bfp-anchor-options]'),
      anchorPrice: root.querySelector('[data-bfp-anchor-price]')
    };

    function countSelected() { return Object.keys(state.selected).length; }

    // ---------- anchor (size locked, static pill) ----------
    (function renderAnchor() {
      if (!anchor || !el.anchorOptions) return;
      el.anchorOptions.innerHTML = '';
      var lock = lockedSize(anchor);
      if (lock) {
        var chip = document.createElement('span');
        chip.className = 'bfp-pill bfp-pill--anchor';
        chip.textContent = lock.value;
        el.anchorOptions.appendChild(chip);
      } else {
        anchor.options.forEach(function (opt) {
          if (!opt.values || opt.values.length <= 1) return;
          el.anchorOptions.appendChild(buildSelect(opt, state.anchorValues[opt.position - 1], function (val) {
            state.anchorValues[opt.position - 1] = val; syncAnchor();
          }));
        });
      }
      syncAnchor();
    })();

    function syncAnchor() {
      var v = findVariant(anchor, state.anchorValues) || state.anchorVariant;
      state.anchorVariant = v;
      if (el.anchorPrice) el.anchorPrice.textContent = v ? money(v.price, cfg) : '';
      recalc();
    }

    // ---------- pool cards ----------
    cfg.pool.forEach(function (product) { el.pool.appendChild(buildCard(product)); });
    if (!anchor) recalc();

    function buildCard(product) {
      var lock = lockedSize(product);
      var variant = fixedVariant(product, SCENT); // one fixed variant — no scent/size choice
      var available = !!(variant && variant.available);
      var sizeText = lock ? lock.value : (variant ? variant.title : '');
      var si = scentOptIndex(product);
      var scentText = (si >= 0 && variant) ? variant.options[si] : '';

      var card = document.createElement('div');
      card.className = 'bfp-card' + (available ? '' : ' bfp-card--soldout');
      card.setAttribute('data-handle', product.handle);

      var imgHtml = product.image
        ? '<img class="bfp-card__img" src="' + product.image + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="120" height="120">'
        : '<div class="bfp-card__img bfp-card__img--empty"></div>';

      var badgeHtml = '<span class="bfp-pill__badge" data-card-badge>SAVE ' + ENTRY + '%</span>';
      var usageHtml = product.usage ? '<span class="bfp-pill__usage">' + escapeHtml(product.usage) + '</span>' : '';
      var pillHtml = sizeText
        ? '<div class="bfp-pillwrap">' + badgeHtml + '<span class="bfp-pill">' + escapeHtml(sizeText) + '</span>' + usageHtml + '</div>'
        : '';
      var scentHtml = scentText ? '<div class="bfp-card__scent">' + escapeHtml(scentText) + '</div>' : '';

      card.innerHTML =
        '<div class="bfp-card__media">' + imgHtml + '</div>' +
        '<div class="bfp-card__body">' +
        '<div class="bfp-card__title">' + escapeHtml(product.title) + '</div>' +
        pillHtml +
        scentHtml +
        '<div class="bfp-card__price" data-card-price>' + (variant ? money(variant.price, cfg) + (available ? '' : ' — sold out') : 'Unavailable') + '</div>' +
        '<button type="button" class="bfp-card__toggle" data-card-toggle aria-pressed="false"' + (available ? '' : ' disabled') + '>' +
        '<span class="bfp-card__tick" aria-hidden="true"></span><span data-toggle-label>Add to pack</span></button>' +
        '</div>';

      var toggle = card.querySelector('[data-card-toggle]');

      toggle.addEventListener('click', function () {
        if (toggle.disabled) return;
        if (state.selected[product.handle]) {
          delete state.selected[product.handle];
          card.classList.remove('bfp-card--selected');
          toggle.setAttribute('aria-pressed', 'false');
        } else {
          if (countSelected() >= MAX) return; // cap at MAX add-ons
          state.selected[product.handle] = { product: product, variant: variant };
          card.classList.add('bfp-card--selected');
          toggle.setAttribute('aria-pressed', 'true');
        }
        recalc();
      });

      return card;
    }

    // ---------- tier ladder highlight ----------
    function paintTiers(n, pct) {
      if (!el.tiers) return;
      var reachedMin = 0;
      TIERS.forEach(function (t) { if (n >= t.min) reachedMin = t.min; });
      Array.prototype.forEach.call(el.tiers.querySelectorAll('[data-tier-min]'), function (chip) {
        var min = parseInt(chip.getAttribute('data-tier-min'), 10);
        chip.classList.toggle('is-reached', n >= min);
        chip.classList.toggle('is-current', n > 0 && min === reachedMin);
      });
    }

    // ---------- pricing + tiers ----------
    function recalc() {
      var n = countSelected();
      var pct = tierPct(n);
      var nt = nextTier(n);
      var shownPct = pct || ENTRY;

      // live SAVE badge on every add-on card reflects the current tier
      root.querySelectorAll('[data-card-badge]').forEach(function (b) { b.textContent = 'SAVE ' + shownPct + '%'; });

      paintTiers(n, pct);

      // selected/labels + cap: once MAX are chosen, lock the rest
      var full = n >= MAX;
      root.querySelectorAll('.bfp-card').forEach(function (card) {
        var isSelected = !!state.selected[card.getAttribute('data-handle')];
        var toggle = card.querySelector('[data-card-toggle]');
        var label = card.querySelector('[data-toggle-label]');
        var soldout = card.classList.contains('bfp-card--soldout');
        if (soldout && !isSelected) {
          if (toggle) toggle.disabled = true;
          card.classList.remove('bfp-card--locked');
          if (label) label.textContent = 'Sold out';
        } else if (isSelected) {
          if (toggle) toggle.disabled = false;
          card.classList.remove('bfp-card--locked');
          if (label) label.textContent = 'In your pack — Remove';
        } else if (full) {
          if (toggle) toggle.disabled = true;
          card.classList.add('bfp-card--locked');
          if (label) label.textContent = 'Pack full (' + MAX + ')';
        } else {
          if (toggle) toggle.disabled = false;
          card.classList.remove('bfp-card--locked');
          if (label) label.textContent = 'Add to pack';
        }
      });

      // counter / nudge
      if (el.counter) {
        if (cfg.gateLabel && n < MIN) {
          var need = MIN - n;
          el.counter.textContent = 'Add ' + need + ' more to unlock ' + ENTRY + '% off — ' + n + ' of ' + MIN + ' chosen';
        } else if (cfg.gateLabel) {
          el.counter.textContent = '✓ ' + (n + 1) + '-oil bundle · 25% off all ' + (n + 1);
        } else if (n === 0) el.counter.textContent = 'Add up to ' + MAX + ' — save ' + shownPct + '%';
        else if (nt) el.counter.textContent = 'Saving ' + pct + '% — add 1 more for ' + nt.pct + '%';
        else el.counter.textContent = n + (n === 1 ? ' item' : ' items') + ' in your pack · saving ' + pct + '%';
        el.counter.classList.toggle('bfp__counter--met', n >= MIN);
      }

      var anchorCents = state.anchorVariant ? state.anchorVariant.price : 0;
      var addonsCents = 0;
      var allResolved = true;
      Object.keys(state.selected).forEach(function (h) {
        var s = state.selected[h];
        if (s.variant && s.variant.available) addonsCents += s.variant.price;
        else allResolved = false;
      });

      var discountBase = cfg.discountAnchor ? (anchorCents + addonsCents) : addonsCents;
      var saving = Math.round(discountBase * pct / 100);
      var fullTotal = anchorCents + addonsCents;
      var discounted = fullTotal - saving;

      if (el.subtotal) el.subtotal.textContent = money(fullTotal, cfg);
      if (el.saving) el.saving.textContent = '−' + money(saving, cfg);
      if (el.savingPct) el.savingPct.textContent = shownPct;
      if (el.total) el.total.textContent = money(discounted, cfg);

      if (el.freeship) {
        if (FREE > 0 && n > 0) {
          var remain = FREE - discounted;
          el.freeship.hidden = false;
          if (remain > 0) {
            el.freeship.classList.remove('bfp__freeship--met');
            el.freeship.textContent = "You're " + money(remain, cfg) + ' away from free shipping';
          } else {
            el.freeship.classList.add('bfp__freeship--met');
            el.freeship.textContent = '✓ Your pack ships free';
          }
        } else { el.freeship.hidden = true; }
      }

      var ready = n >= MIN && allResolved && (cfg.anchorless || (state.anchorVariant && state.anchorVariant.available));
      root.classList.toggle('bfp--ready', ready);
      if (el.ctaLabel) el.ctaLabel.textContent = ready ? ((cfg.ctaReadyPrefix || 'Add my pack — save ') + money(saving, cfg)) : (cfg.buttonLabel || 'Add to cart');
      if (!root.classList.contains('bfp--loading')) el.cta.disabled = !ready;
      if (el.error) el.error.hidden = true;
    }

    // ---------- add to cart ----------
    el.cta.addEventListener('click', function () {
      if (el.cta.disabled) return;
      var items = cfg.anchorless ? [] : [{ id: state.anchorVariant.id, quantity: 1, properties: { _pack_role: 'anchor', _bundle: cfg.packTag } }];
      Object.keys(state.selected).forEach(function (h) {
        items.push({ id: state.selected[h].variant.id, quantity: 1, properties: { _pack: cfg.packTag, _pack_role: 'addon' } });
      });
      addToCart(items);
    });

    function addToCart(items) {
      setLoading(true);
      // Don't add a second Mould Spray if the shopper already has one in the cart.
      var cartJsUrl = (cfg.cartUrl || '/cart').replace(/\/+$/, '') + '.js';
      fetch(cartJsUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var anchorInCart = anchor ? (cart.items || []).some(function (it) { return it.product_id === anchor.id; }) : false;
          var finalItems = anchorInCart
            ? items.filter(function (it) { return !(it.properties && it.properties._pack_role === 'anchor'); })
            : items;
          if (!finalItems.length) finalItems = items; // safety: never send an empty add
          postAdd(finalItems);
        });
    }

    function postAdd(items) {
      var payload = { items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };
      fetch(cfg.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            showError((res.data && (res.data.description || res.data.message)) || 'Sorry, we couldn’t add the pack. Please try again.');
            setLoading(false); return;
          }
          try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bleach-free-pack' }); } catch (e) {}
          // Apply the pack discount code, then land on the cart (the code shows there).
          if (cfg.discountCode) {
            var cu = cfg.cartUrl || '/cart';
            window.location.href = '/discount/' + encodeURIComponent(cfg.discountCode) + '?redirect=' + encodeURIComponent(cu);
            return;
          }
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (cart && typeof cart.renderContents === 'function') { cart.renderContents(res.data); setLoading(false); }
          else { window.location = cfg.cartUrl || '/cart'; }
        })
        .catch(function (e) { console.error('[BFP] add to cart failed', e); showError('Something went wrong adding your pack. Please try again.'); setLoading(false); });
    }

    function setLoading(v) {
      root.classList.toggle('bfp--loading', v);
      el.cta.classList.toggle('bfp-add--loading', v);
      if (v) el.cta.disabled = true; else recalc();
    }
    function showError(msg) { if (el.error) { el.error.textContent = msg; el.error.hidden = false; } }

    recalc();
  }

  function initAll() { document.querySelectorAll('[data-bfp-root]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
